import { baseApi } from 'api'
import { ApiResponse } from 'helpers/types'
import { CargoSizeItem, CargoSizeListResponse } from 'schema'
import { TypeRootState } from 'store/store'

export const cergoSizeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCargoSize: build.query<CargoSizeItem[], void>({
      query: () => ({
        url: 'cargo-size',
        method: 'GET'
      }),
      transformResponse: (response: ApiResponse<CargoSizeListResponse>) => response.data.cargoSize,
      forceRefetch: () => true
    })
  }),
  overrideExisting: false
})

export const { useGetCargoSizeQuery } = cergoSizeApi

const cargoSizeSelector = cergoSizeApi.endpoints.getCargoSize.select()
export const cargoSizeDataSelector = (state: TypeRootState) => cargoSizeSelector(state).data
